import React from 'react'

function Support() {
  return (
    <>
      <div className="container-fluid">
        <div className="text-center ">
          <div className="bold">
            <h1>Support</h1>
          </div>
        </div>
      </div>
    </>
  );
}

export default Support